<template>
    <div class="modal fade" id="importHistoryModal" tabindex="-1" aria-labelledby="importHistoryModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content bg-white">
                <div class="modal-header">
                    <div class="d-flex align-items-start w-100">
                        <h5 class="modal-title mb-0" :id="modalLabelId" style="flex: 1 1 auto; min-width: 0; margin-right: 1rem;" data-bs-toggle="tooltip" title="Import from Google Docs">
                            <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block; max-width: calc(100% - 60px); vertical-align: middle;">
                                Import from Google Docs
                            </span>
                        </h5>
                        <div class="d-flex align-items-center" style="flex: 0 0 auto;">
                            <button type="button" class="btn btn-white close-modal" data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="tooltip" title="Close">
                                <img class="icon" src="/img/icons/avid-icons/close.svg" alt="">
                            </button>
                        </div>
                    </div>
                </div>
                <div class="table-card p-0 mb-4">
                    <table class="table table-width-responsive table-without-pagination mb-0">
                        <thead>
                            <tr class="table-header-row">
                                <th class="d-table-cell bg-white column-sort-disabled" style="width: 200px;">
                                    <div class="d-flex flex-row">
                                        Touchpoints
                                    </div>
                                </th>
                                <th @click="sortByKey('created_at')" class="d-table-cell bg-white" style="cursor: pointer;">
                                    <div class="d-flex flex-row">
                                        Created At
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{'sort-key-active': sort_key === 'created_at' && sort_order === 'asc'}" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{'sort-key-active': sort_key === 'created_at' && sort_order === 'des'}" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th @click="sortByKey('imported_at')" class="d-table-cell bg-white" style="cursor: pointer;">
                                    <div class="d-flex flex-row">
                                        Imported At
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{'sort-key-active': sort_key === 'imported_at' && sort_order === 'asc'}" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{'sort-key-active': sort_key === 'imported_at' && sort_order === 'des'}" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th class="table-column-action column-sort-disabled d-table-cell bg-white pe-3" width="1"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr 
                                v-for="(history, index) in sortedHistory" 
                                :key="history.id"
                                :class="`table-row-${index + 1}`"
                            >
                                    <td class="d-table-cell channels-column">
                                        <div class="position-relative text-nowrap">
                                            <template v-for="(asset_type, index) in getUniqueAssetTypes(history.assets)" :key="asset_type.id">
                                                <span class="d-inline-block" data-bs-toggle="tooltip" :title="getAssetNamesForType(history.assets, asset_type.id)">
                                                    <button class="btn btn-secondary btn-icon-only-sm" disabled style="pointer-events: none;" aria-label="Button">
                                                        <img :src="'/img/icons/avid-icons/' + asset_type.icon_class + '.svg'" class="asset-type-icon icon" alt=""></img>
                                                    </button>
                                                </span>
                                            </template>
                                            <span class="text-muted"> ({{history.assets.length}})</span>
                                        </div>
                                    </td>
                                    <td class="d-table-cell align-start text-start">{{ datetime(history.created_at) }}</td>
                                    <td class="d-table-cell align-start text-start">
                                        <div class="text-muted">
                                            <span v-if="history.imported_at">{{ datetime(history.imported_at) }}</span>
                                            <span v-else>--</span>
                                        </div>
                                    </td>
                                    <td class="column-sort-disabled d-table-cell">
                                        <div class="dropdown d-flex justify-content-center">
                                            <button 
                                                class="btn btn-white btn-icon-only-md" 
                                                data-bs-toggle="dropdown" 
                                                data-bs-auto-close="true" 
                                                aria-expanded="false"
                                             aria-label="Button">
                                                <img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" data-bs-toggle="tooltip" title="Actions" alt="">
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                                <a 
                                                    class="dropdown-item" 
                                                    target="_blank" 
                                                    :href="history.url"
                                                >
                                                    <img class="icon me-2" src="/img/icons/avid-icons/arrow-up-right.svg" alt=""> View in Google Docs
                                                </a>
                                                <a 
                                                    class="dropdown-item" 
                                                    href="#" 
                                                    @click.prevent="importFromGoogleDoc(history.id)"
                                                >
                                                    <img class="icon me-2" src="/img/icons/avid-icons/download.svg" alt=""> Import Edits into Avid
                                                </a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { useNotifications } from '../../composables/useNotifications';

export default defineComponent({
    name: 'ImportHistoryModal',
    setup() {
        const { showNotification } = useNotifications();
        return {
            showNotification
        };
    },
    props: {
        histories: {
            type: Array,
            required: true
        },
        client: {
            type: Object,
            required: true
        },
        playbook: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            modalLabelId: 'importHistoryModalLabel',
            sort_key: 'created_at',
            sort_order: 'des'
        }
    },
    computed: {
        sortedHistory() {
            return [...this.histories].sort((a, b) => {
                let aValue = a[this.sort_key];
                let bValue = b[this.sort_key];

                // Handle special cases for sorting
                if (this.sort_key === 'created_at' || this.sort_key === 'imported_at') {
                    aValue = new Date(aValue);
                    bValue = new Date(bValue);
                } else if (this.sort_key === 'created_by') {
                    aValue = a.creator?.name || '';
                    bValue = b.creator?.name || '';
                }

                if (this.sort_order === 'asc') {
                    return aValue > bValue ? 1 : -1;
                } else {
                    return aValue < bValue ? 1 : -1;
                }
            });
        }
    },
    methods: {
        sortByKey(key) {
            if (this.sort_key === key) {
                this.sort_order = this.sort_order === 'asc' ? 'des' : 'asc';
            } else {
                this.sort_key = key;
                this.sort_order = 'asc';
            }
        },

        getUniqueAssetTypes(assets) {
            if (!assets || assets.length === 0) return [];
            const uniqueTypes = new Map();
            assets.forEach(asset => {
                if (asset.asset_type && !uniqueTypes.has(asset.asset_type.id)) {
                    uniqueTypes.set(asset.asset_type.id, asset.asset_type);
                }
            });
            return Array.from(uniqueTypes.values());
        },

        getAssetNamesForType(assets, assetTypeId) {
            if (!assets || assets.length === 0) return '';
            const assetNames = assets
                .filter(asset => asset.asset_type && asset.asset_type.id === assetTypeId)
                .map(asset => asset.name)
                .filter(name => name); // Filter out any null/undefined names
            return assetNames.join(', ') || '';
        },

        importFromGoogleDoc(history_id) {
            // Close the modal
            const modal = bootstrap.Modal.getInstance(document.getElementById('importHistoryModal'));
            if (modal) {
                modal.hide();
            }

            window.axios.post(`/api/playbooks/${this.client.url}/import_doc/${this.playbook.url}`, {
                playbook_export_history_id: history_id
            }).then(response => {
                if (response.data.success) {
                    //Update the local_history to show the imported_at date
                    this.$emit('refresh-history', history_id);

                    this.showNotification({
                        text: 'Successfully imported from Google Doc!'
                    });
                } else {
                    this.showNotification({
                        text: 'Failed to import from Google Doc. Please try again.',
                        type: 'error'
                    });
                }
            })
            .catch(error => {
                this.showNotification({
                    text: 'Error: ' + (error.response?.data?.error || 'Failed to import from Google Doc. Please try again.'),
                    type: 'error'
                });
            });
        },
    },
    mounted() {
        // Initialize tooltips
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl);
        });
    },
})
</script>
